export { default as DocumentosAlunoBrasileiro } from './documentos-do-aluno-brasileiro.component'
export { default as DocumentosAlunoEstrangeiro } from './documentos-do-aluno-estrangeiro.component'
export { default as DocumentosProfessorBrasileiro } from './documentos-do-professor-brasileiro.component'
export { default as DocumentosProfessorEstrangeiro } from './documentos-do-professor-estrangeiro.component'
export * from './tipos'
